import type { SxProps, Theme } from '@mui/material/styles';
import colors from '../../themes/colors';
import {
  getCategoryLabelStyle,
  getStatusLabelStyle,
  type CategoryTone,
  type StatusTone,
} from '../../themes/labels';

export type LabelSize = 'small' | 'medium';

const LABEL_FONT_SIZE = 10;
const LABEL_FONT_WEIGHT = 600;
const LABEL_ICON_GAP = 0.35;

export function getBaseLabelSx(size: LabelSize = 'small'): SxProps<Theme> {
  return {
    // small=18: 테이블 본문 줄높이(≈18.85px)와 맞춰 칩이 행을 키우지 않게
    height: size === 'medium' ? 24 : 18,
    minHeight: size === 'medium' ? 24 : 18,
    maxWidth: '100%',
    fontSize: size === 'medium' ? 11 : LABEL_FONT_SIZE,
    fontWeight: LABEL_FONT_WEIGHT,
    px: 0.75,
    borderRadius: `${colors.radiusPx.pill}`,
    boxShadow: 'none',
    '& .MuiChip-icon': {
      fontSize: size === 'medium' ? 13 : 12,
      marginLeft: '2px',
      marginRight: `-${LABEL_ICON_GAP * 8}px`,
    },
    '& .MuiChip-label': {
      px: 0.35,
      whiteSpace: 'nowrap',
      lineHeight: 1.2,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: 'inherit',
    },
  };
}

export function getStatusChipSx(tone: StatusTone, size: LabelSize = 'small'): SxProps<Theme> {
  const style = getStatusLabelStyle(tone);
  return {
    ...getBaseLabelSx(size),
    bgcolor: style.background,
    color: style.text,
    border: `1px solid ${style.border}`,
    '&:hover': {
      bgcolor: style.background,
    },
  };
}

export function getCategoryChipSx(
  tone: CategoryTone,
  size: LabelSize = 'small',
  selected = false,
): SxProps<Theme> {
  const style = getCategoryLabelStyle(tone);
  return {
    ...getBaseLabelSx(size),
    bgcolor: style.background,
    color: style.text,
    border: selected ? `2px solid ${style.text}` : `1px solid ${style.border}`,
    fontWeight: selected ? 700 : LABEL_FONT_WEIGHT,
    '&:hover': {
      bgcolor: style.background,
    },
  };
}

export function getSelectedCategoryChipSx(tone: CategoryTone, size: LabelSize = 'small'): SxProps<Theme> {
  return getCategoryChipSx(tone, size, true);
}
